import { IJSendSuccessResponse } from "typings";
import { fetcher } from "utils";

type SMSAuthRequest = (payload: { phone_number: string; country_code?: string }) => Promise<IJSendSuccessResponse<{}>>;

export const postSMSAuth: SMSAuthRequest = payload => fetcher.post("/api/v1/sms_auth", payload);
